import { put } from "redux-saga/effects";
import { DocTypes } from "../../common/constants/DocTypes";
import { requestIntakeIntelligenceActionCreator, resetIntakeIntelligenceActionCreator } from "./IntakeDucks";

export interface AutoExtractOnRequestUploadParams {
    recordType: DocTypes | string | undefined;
    organizationId: number;
    requestBufferId: number;
    /**
     * DataEntryDetails.isQuickEntryEligible() at dispatch time (the same value gating the
     * "Classic Mode" toolbar button - see DataEntryDetailsBody.uploadFiles). Single source of
     * truth for "is Quick Entry the active mode", rather than re-deriving eligibility here.
     */
    quickEntryActive: boolean | undefined;
}

/**
 * Spec #34100 / F1b-rois — auto-extract-on-attach (AC1/AC2/AC3).
 *
 * On a request-document (DocTypes.REQ) upload, reset the prior analysis (AC2) then run the POST
 * extraction (AC1, requestIntakeIntelligence — replacing the old GET). A non-REQ / append upload
 * (AC3) is a no-op via the recordType gate.
 *
 * Bug fix (direct user report): this trigger only belongs to Quick Entry's document-first flow.
 * Classic mode - including the old-Intake "Extract" button surface, which must stay a manual,
 * explicit click - was firing this same auto-extraction on every REQ upload/replace/append,
 * because the original recordType-only gate had no mode check. See quickEntryActive above.
 *
 * Takes a single params object (rather than positional args) partly for clarity and partly
 * because redux-saga's call() typings on this project's TS version fail overload resolution
 * past 3 positional args on a generator function.
 *
 * Extracted into its own module (imports only put + DocTypes + the intake action creators) so the
 * trigger can be unit-tested in isolation, deliberately avoiding DataEntryDetailsDucks' heavy,
 * node:stream-tainted import chain (services/Network etc.) that prevents that suite from loading.
 */
export function* autoExtractOnRequestUpload(params: AutoExtractOnRequestUploadParams) {
    if (params.recordType !== DocTypes.REQ || !params.quickEntryActive) {
        return;
    }
    yield put(resetIntakeIntelligenceActionCreator());
    yield put(requestIntakeIntelligenceActionCreator(params.organizationId, params.requestBufferId));
}
